<div class="fixed right-4 bottom-20 lg:bottom-8 lg:right-8 z-feature flex flex-col items-center gap-3">
  <slot />
</div>
